import React from "react";
import { CreateContainer } from "./ContainerCreate";
import { getThisDayPosts } from "../api/getThisDayPosts";

class ThisDayContainer extends React.Component {
  componentDidMount() {
    this.props.request();
  }
  render = () => {
    const { data, loading, failure, render } = this.props;
    const result = (data && data.data) || {};
    const posts = (result && result.posts) || [];
    return render({ posts, loading, failure });
  };
}

ThisDayContainer.defaultProps = {};
export default CreateContainer(getThisDayPosts, ThisDayContainer);
